<div>
  @if (openClose) {
    <div id="sidenav" [@myAnimation]>
      <div id="menu-top" class="primary">
        <div class="system-name">
          <h1>
            <img id="application-logo" title="SAP - Sistema de Avaliação Prática - Área Restrita" class="logo-size" src="/assets/img/logos/logo-sap-interna.png">
          </h1>
        </div>
      </div>
      <mat-card class="flex user-section">
        @if (user) {
          <div class="profile-spot">
            <img id="profile-image" [src]="user?.avatar_path" (error)="fixAvatar()">
          </div>
        }
        <div>
          <p class="user-name">{{user?.name}}</p>
          @if (user?.application) {
            <div class="profile-list">
              @for (profile of user?.application?.profiles; track profile; let i = $index) {
                <p class="user-title "
                matTooltip="{{profile?.access_profile?.tip}}">{{profile?.access_profile?.description}}</p>
              }
            </div>
          }
          @if (user?.application?.profiles?.length == 0) {
            <div class="no-profile">
              <p class="user-title" matTooltip="Procure seu Interlocutor ou Coordenador para que seja providenciado o seu Perfil de Acesso.">
                Perfil de Acesso não definido para a Aplicação ativa
              </p>
            </div>
          }
          <div class="session-options">
            @if (user && !mobileQuery.matches) {
              <a  mat-icon-button
                matTooltip="Perfil"
                matTooltipPosition="below"
                routerLink='/main/user/profile'
                routerLinkActive="active-link">
                <mat-icon mat-list-icon>person</mat-icon>
              </a>
            }
            @if (applicationsArray) {
              <a  mat-icon-button
                matTooltip="Mensagens"
                matTooltipPosition="below"
                routerLink='/main/communication-center'
                routerLinkActive="active-link">
                <mat-icon mat-list-icon>email</mat-icon>
              </a>
            }
            @if (applicationsArray) {
              <a  mat-icon-button
                matTooltip="FAQ"
                matTooltipPosition="below"
                routerLink='/main/faq-view'
                routerLinkActive="active-link">
                <mat-icon mat-list-icon>contact_support</mat-icon>
              </a>
            }
            <button mat-icon-button (click)="logout()" matTooltip="Encerrar sessão" matTooltipPosition="below">
              <mat-icon mat-list-icon>exit_to_app</mat-icon>
            </button>
          </div>
        </div>
      </mat-card>
      @if (mainComponent.getTermConfirmation()) {
        <div class="scroll side-menu-background">
          <a routerLink='/main/dashboard' mat-button id="menu-button" routerLinkActive="active-link">
            Monitoramento do Sistema
          </a>
          @for (tool of groupedMenuSettings; track tool) {
            <div class="primary-text group">
              <div class="section">
                {{tool.category}}
              </div>
              <div class="group-section" >
                @for (val of tool.items; track val) {
                  <button class="menu-item" (click)="onMenuRoute(val.route)" mat-button id="menu-button" [routerLink]="val.route" routerLinkActive="active-link">{{val.description}}</button>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (errors.length > 0) {
    <span>
      @for (error of errors; track error) {
        <mat-error>{{error.cod}} - {{error.message}}</mat-error>
      }
    </span>
  }
</div>
